<div class="m-4">
  <div class="row">
    <div class="col-6">
      <p class="titleFont">{{ title }}</p>
    </div>
    <div class="col-6 text-right">
      <div>
        <custom-button
          class="addButton"
          label="{{ 'processClaims.decisionAndSettlement.add' | translate }}"
          mode="secondary"
          [iconSrc]="addIcon"
          (onClick)="onAddNote()"
          iconPosition="after"
          [disabled]="data.disable"
        >
        </custom-button>
      </div>
    </div>
  </div>
  <div class="card px-3 py-4">
    <ng-container *ngIf="supperlogin() && data.department=='AF'">
     <ng-container *ngFor="let note of anotation; let i = index">
      <div class="row mb-2">
        <div class="col-10">
          <dxc-textarea
            (onChange)="onChange($event, i)"
            [value]="note.summary.freeText"
            [disabled]="true"
          >
          </dxc-textarea>
        </div>
        <div class="d-flex col-2 Image px-0">
            <img src="{{ editIcon }}" alt="" class="disable-row"/>
            <img
              class="mx-3 disable-row"
              src="{{ uploadIcon }}"
              alt=""
            />
            <img src="{{ deleteIcon }}" alt="" class="disable-row"/>
        </div>
      </div>
     </ng-container>
    </ng-container>
    <ng-container *ngFor="let note of notes; let i = index">
      <div class="row mb-2">
        <div class="col-10">
          <dxc-textarea
            (onChange)="onChange($event, i)"
            [value]="note.notesDesc"
            (onBlur)="onDataBlur(note, i)"
            [disabled]="!note.isEdit || data.disable"
          >
          </dxc-textarea>
        </div>
        <div class="d-flex col-2 Image px-0">
          <ng-container *ngIf="showUpload">
            <img src="{{ editIcon }}" alt="" (click)="!data.disable?onEditNote(i):''" [ngClass]="{'disable-row':data.disable}"/>
            <img
              class="mx-3"
              src="{{ uploadIcon }}"
              (click)="!data.disable?onFileUpload(note):''"
              alt=""
              [ngClass]="{'disable-row':data.disable}"
            />
            <img src="{{ deleteIcon }}" alt="" (click)="!data.disable?onDeleteNote(i):''" [ngClass]="{'disable-row':data.disable}"/>
          </ng-container>
          <ng-container *ngIf="!showUpload">
            <img class="mx-2" src="{{ editIcon }}" alt="" />
            <img
              class="mx-2"
              src="{{ deleteIcon }}"
              alt=""
              (click)="onDeleteNote(i)"
            />
          </ng-container>
        </div>
      </div>
      <div class="row">
        <div
          class="pl-3 ml-2"
          *ngIf="note.document && note.document.documentFileName !== ''"
        >
          <span class="fullDocName">{{ note.document.documentFileName }}</span>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="row endButtons">
    <ng-container *ngIf="!showUpload">
      <custom-button
        class="saveBtn"
        label="{{ 'processClaims.decisionAndSettlement.save' | translate }}"
        mode="primary"
        margin="xsmall"
        (onClick)="onCloseDialog()"
      >
      </custom-button>
      <custom-button
        class="cancelBtn"
        label="{{ 'processClaims.decisionAndSettlement.cancel' | translate }}"
        mode="secondary"
        margin="xsmall"
        (onClick)="onCloseDialog()"
      >
      </custom-button>
    </ng-container>
    <ng-container *ngIf="showUpload">
      <custom-button
        class="saveBtn"
        label="{{ 'processClaims.decisionAndSettlement.save' | translate }}"
        mode="primary"
        margin="xsmall"
        (onClick)="onCloseDialog()"
        [disabled]="data.disable"
      >
      </custom-button>
      <custom-button
        class="cancelBtn"
        label="{{ 'Approve Task' | translate }}"
        mode="secondary"
        margin="xsmall"
        [disabled]="(!claimAuthority.investigationSubtask.actions.approveSubtask)"
        (onClick)="onApproveTask()"
        [disabled]="data.disable"
      >
      </custom-button>
      <custom-button
        class="cancelBtn"
        label="{{ 'processClaims.decisionAndSettlement.cancel' | translate }}"
        mode="secondary"
        margin="xsmall"
        (onClick)="onCloseDialog()"
      >
      </custom-button>
    </ng-container>
  </div>
</div>

<!-- Dialog box for File Upload. -->
<div class="dialog-upload-file">
  <ng-container *ngIf="isDialogUpload">
    <dxc-dialog
      [isCloseVisible]="true"
      padding="xsmall"
      (onCloseClick)="onFileUpload([])"
      (onBackgroundClick)="onFileUpload([])"
    >
      <div class="dialog-upload-label">
        <Label>{{ "claim.claimantDetail.uploadDocument" | translate }}</Label>
      </div>
      <div class="choose-file-upload">
        <custom-file-input
          [mode]="'dropzone'"
          [multiple]="false"
          [showPreview]="true"
          (onUpload)="onUploadFile($event)"
        >
        </custom-file-input>
      </div>
    </dxc-dialog>
  </ng-container>
</div>
